/* eslint-disable @typescript-eslint/no-namespace */

import { FunctionType, PermissionType } from '../../../../../../const/UserPermission';
import { PracticeDetailFragment, useGetPracticeQuery } from '../../../../../../gen/graphql';
import { Breadcrumb } from '../../../../../organisms/Breadcrumb';

export namespace PracticeExplanationFunctions {
  export function getPermissions(permissionCheck: (functionType: string, permissionType: string) => boolean) {
    return {
      programForInstructorAndCoachRead: permissionCheck(FunctionType.ProgramForInstructorAndCoach, PermissionType.Read),
    };
  }

  export function useGetPractice(
    practiceID: string,
    onCompleted?: (practice: PracticeDetailFragment | null | undefined) => void,
  ): ReturnType<typeof useGetPracticeQuery> {
    return useGetPracticeQuery({
      variables: {
        practiceID: practiceID,
      },
      onCompleted: (data) => {
        onCompleted?.(data.practice);
      },
    });
  }

  export function onBackButtonClick(practiceID: string, navigate: (path: string) => void): void {
    return navigate(`/practices/${practiceID}/body`);
  }

  export function getBreadcrumbs(
    practice: PracticeDetailFragment | null | undefined,
    permissions: ReturnType<typeof getPermissions>,
  ): Breadcrumb.Items {
    return [
      {
        label: 'ホーム',
        to: '/home',
      },
      {
        label: '教材',
        to: permissions.programForInstructorAndCoachRead ? '/programs?type=1' : '/programs',
      },
      {
        label: practice?.program.title ? practice?.program.title : '章一覧',
        to: practice?.program.id ? `/programs/${practice?.program.id}/chapters` : '',
      },
      {
        label: practice?.title ? practice.title : '現在のページ',
      },
    ];
  }
}
